import React from 'react';
import { VfModal } from '@vfit/shared/components';
import MoreOfferElement from '../MoreOfferElement/moreOfferElement';
import { IMoreOfferMobilePopup } from './moreOfferMobilePopup.models';
import { purify } from '@vfit/shared/themes';
import { PopupTitle } from './moreOfferMobilePopup.style';

const MoreOfferMobilePopup = ({
  titlePopup,
  elements,
  handleCloseModal,
}: IMoreOfferMobilePopup) => {
  const [pTitlePopup] = purify([titlePopup]);
  return (
    <VfModal height={563} isOpen handleClose={handleCloseModal}>
      <>
        {pTitlePopup && <PopupTitle dangerouslySetInnerHTML={{ __html: pTitlePopup }} />}
        {elements?.map((element) => {
          return (
            <MoreOfferElement
              label={element?.title || ''}
              url={element?.url || ''}
              enableRedirect
              arrow={'right'}
              border="no-border"
            />
          );
        })}
      </>
    </VfModal>
  );
};

export default MoreOfferMobilePopup;
